import React from "react";
import { FieldGroup, SelectField } from "@td/ui";
import { useStates } from "../contexts/states-context";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

const StateField = React.memo(() => {
  const states = useStates();

  return (
    <FieldGroup>
      <SelectField
        isMulti
        closeMenuOnSelect={false}
        name={fieldTypes.STATES}
        options={states}
        label={translate(null, "practice_team.editing.fields.states", "label")}
        placeholder={translate(null, "practice_team.editing.fields.states", "placeholder")}
        formatOptionLabel={(option, { context }) => (context === "menu" ? option.label : option.value)}
      />
    </FieldGroup>
  );
});

export default StateField;
